import React from "react";

export default function IconExit() {
  return (
    <svg
      className="svg"
      xmlns="http://www.w3.org/2000/svg"
      height="40"
      viewBox="0 0 24 24"
      width="40"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM21 3H3v6h2V5h14v14H5v-4H3v6h18V3z" />
    </svg>
  );
}
